<template>
  <div
    class="notification-container"
    :class="{ 'notification-overlay': imageOverlay }"
    :style="{ 'background-color': colorOverlay }"
  >
    <div class="notification-text">
      <slot />
    </div>
    <div v-if="$slots.hasOwnProperty('button')" class="notification-button">
      <slot name="button" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colorOverlay: {
      type: String,
      default() {
        return '';
      },
    },
    imageOverlay: {
      type: String,
      default() {
        return '';
      },
    },
  },
};
</script>

<style lang="sass" scoped>
  .notification-container
    width: 100%
    display: flex
    flex-flow: row wrap
    align-items: center
    justify-content: space-between
    padding: 20px
    overflow: hidden
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    box-sizing: border-box

    +respond-to("medium")
      padding: 30px 20px
      border-radius: 5px

    #{theme("eclipse")} &
      background-color: #E5E5E5

    #{theme("obsidian")} &
      background-color: #181722

  .notification-text
    flex: 1
    font-size: 16px
    font-weight: 400
    line-height: 20px

  .notification-button
    flex: none
    width: 100%
    margin-top: 20px
    z-index: 10

    +respond-to("small")
      width: auto
      margin-top: 0
      margin-left: 17px

  .notification-overlay
    position: relative

    &:after
      content: ''
      width: 169px
      height: 186px
      position: absolute
      top: 50%
      right: -82px
      background-repeat: no-repeat
      background-image: url("~@/assets/img/self-employed/self-employed-white.svg")
      background-size: 100% 100%
      transform: translateY(-50%)

      +respond-to("medium")
        height: 164px
        right: 124px
        background-position: center center
</style>
